var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.modalClass(),attrs:{"id":_vm.isModal ? '' : 'pop-wrapper'}},[(_vm.isModal)?[_c('div',{class:{'modal-flex': _vm.isModal}},[_c('div',{class:{'modal-flex-inner':_vm.isModal},style:(_vm.modalStyle())},[_vm._t("default")],2)])]:_vm._e(),(!_vm.isModal)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }